import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "w-full max-w-[560px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl" }
const _hoisted_3 = { class: "divide-y divide-slate-100" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[150px_1fr] md:items-start" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[150px_1fr] md:items-start" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[150px_1fr] md:items-start" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[150px_1fr] md:items-start" }
const _hoisted_8 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-8 space-y-5" }
const _hoisted_11 = { class: "relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6" }
const _hoisted_12 = { class: "relative flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-3" }
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = { class: "mt-1 text-2xl font-black text-slate-900" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "mt-1 text-2xl font-black text-slate-900" }
const _hoisted_18 = { class: "flex items-center gap-3" }
const _hoisted_19 = { class: "mt-1 text-2xl font-black text-slate-900" }
const _hoisted_20 = {
  key: 0,
  class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
}
const _hoisted_21 = { class: "overflow-x-auto" }
const _hoisted_22 = { class: "min-w-full text-sm" }
const _hoisted_23 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "px-4 py-4 font-bold text-slate-900" }
const _hoisted_27 = { class: "px-4 py-4 text-slate-600" }
const _hoisted_28 = { class: "px-4 py-4" }
const _hoisted_29 = { class: "inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700 capitalize" }
const _hoisted_30 = { class: "px-4 py-4 font-medium text-slate-600" }
const _hoisted_31 = { class: "px-4 py-4" }
const _hoisted_32 = { class: "px-4 py-4 text-xs text-slate-500" }
const _hoisted_33 = { class: "px-4 py-4 text-center" }
const _hoisted_34 = { class: "flex items-center justify-center gap-1" }
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
}
const _hoisted_39 = { class: "flex items-center justify-between gap-3 border-b border-slate-100 px-6 py-4" }
const _hoisted_40 = { class: "overflow-x-auto" }
const _hoisted_41 = { class: "min-w-full text-sm" }
const _hoisted_42 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "px-6 py-4 font-bold text-slate-900" }
const _hoisted_46 = { class: "px-6 py-4 text-slate-600 font-medium" }
const _hoisted_47 = { class: "px-6 py-4" }
const _hoisted_48 = { class: "inline-flex items-center gap-1 font-mono text-xs font-bold text-emerald-700 bg-emerald-50 px-2 py-1 rounded-md" }
const _hoisted_49 = { class: "px-6 py-4 text-slate-600" }
const _hoisted_50 = { class: "px-6 py-4 text-right" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 2,
  class: "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
}
const _hoisted_54 = { class: "flex flex-col gap-3 border-b border-slate-100 px-6 py-4 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_55 = { class: "w-full sm:w-64" }
const _hoisted_56 = { class: "overflow-x-auto" }
const _hoisted_57 = { class: "min-w-full text-sm" }
const _hoisted_58 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "px-6 py-4 text-xs font-medium text-slate-500" }
const _hoisted_62 = { class: "px-6 py-4 font-bold text-slate-900" }
const _hoisted_63 = { class: "px-6 py-4 text-slate-700" }
const _hoisted_64 = { class: "px-6 py-4" }
const _hoisted_65 = { class: "flex flex-col items-start gap-1" }
const _hoisted_66 = { class: "text-xs font-mono text-slate-500" }
const _hoisted_67 = ["title"]
const _hoisted_68 = { class: "px-6 py-4" }
const _hoisted_69 = { class: "flex flex-col items-start gap-1" }
const _hoisted_70 = { class: "text-xs text-slate-500" }
const _hoisted_71 = ["title"]
const _hoisted_72 = {
  key: 0,
  class: "flex items-center justify-between border-t border-slate-100 px-6 py-4"
}
const _hoisted_73 = { class: "text-xs font-medium text-slate-500" }
const _hoisted_74 = { class: "flex gap-2" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["disabled"]

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import IcEdit from '@/assets/svg/ic-edit.vue';
import IcTrash from '@/assets/svg/ic-trash.vue';
import IcPlus from '@/assets/svg/ic-plus.vue';
import {
  GET_BROADCAST_SETTINGS,
  DELETE_BROADCAST_SETTING,
  RUN_BROADCAST,
  GET_BROADCAST_LOGS,
  GET_BROADCAST_MEMBERS,
  DELETE_BROADCAST_MEMBER,
  PUT_BROADCAST_MEMBER,
} from '@/store/broadcast.module';
import FormBroadcastSetting from '@/components/modal/FormBroadcastSetting.vue';
import FormBroadcastRecipient from '@/components/modal/FormBroadcastRecipient.vue';
import type {
  ApiErrorResponse,
  BroadcastDeliveryStatus,
  BroadcastLogsResponse,
  BroadcastRecipient,
  BroadcastRecipientPayload,
  BroadcastRunResponse,
  BroadcastSetting,
} from '@/types/domain';

type BroadcastTab = 'settings' | 'recipients' | 'logs';


export default /*@__PURE__*/_defineComponent({
  __name: 'BroadcastView',
  setup(__props) {

const store = useStore();

const activeTab = ref<BroadcastTab>('settings');

const modalOpen = ref(false);
const editingId = ref<number | undefined>(undefined);
const editingData = ref<Partial<BroadcastSetting>>({});
const addRecipientModalOpen = ref(false);
const editRecipientModalOpen = ref(false);
const editingRecipientId = ref<string | undefined>(undefined);
const savingRecipient = ref(false);
const recipientForm = ref<BroadcastRecipientPayload>({
  name: '',
  nim: '',
  noWhatsapp: '',
  email: '',
});

const loadingSettings = ref(true);
const loadingMembers = ref(false);
const loadingLogs = ref(false);
const blasting = ref<number | null>(null);

const logFilterId = ref('');
const logPage = ref(1);

const settings = computed<BroadcastSetting[]>(() => store.getters.broadcastSettings || []);
const logs = computed<BroadcastLogsResponse>(() => store.getters.broadcastLogs || { data: [], pagination: {} });
const members = computed<BroadcastRecipient[]>(() => store.getters.broadcastMembers || []);
const broadcastFilterOptions = computed(() => [
  { value: '', label: 'Semua Pengaturan' },
  ...settings.value.map((setting) => ({ value: setting.id, label: setting.name })),
]);

onMounted(async () => {
  await store.dispatch(GET_BROADCAST_SETTINGS);
  loadingSettings.value = false;
});

watch(activeTab, async (tab) => {
  if (tab === 'recipients' && !members.value.length) {
    loadingMembers.value = true;
    await store.dispatch(GET_BROADCAST_MEMBERS);
    loadingMembers.value = false;
  }
  if (tab === 'logs') {
    await loadLogs();
  }
});

const openAddRecipient = () => {
  addRecipientModalOpen.value = true;
};

const handleRecipientModalClose = async () => {
  addRecipientModalOpen.value = false;
  loadingMembers.value = true;
  await store.dispatch(GET_BROADCAST_MEMBERS);
  loadingMembers.value = false;
};

const deleteRecipient = async (id: string) => {
  const confirm = await Swal.fire({
    title: 'Hapus penerima ini?',
    text: 'Penerima tidak akan menerima broadcast lagi.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Ya, hapus',
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#8c8c94',
    cancelButtonText: 'Batal'
  });
  if (!confirm.isConfirmed) return;
  try {
    await store.dispatch(DELETE_BROADCAST_MEMBER, id);
    await store.dispatch(GET_BROADCAST_MEMBERS);
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({
      title: 'Error',
      text: apiError?.response?.data?.message || apiError?.message || 'Gagal menghapus.',
      icon: 'error',
      confirmButtonColor: '#003793'
    });
  }
};

const loadLogs = async () => {
  loadingLogs.value = true;
  const settingId = logFilterId.value ? Number(logFilterId.value) : undefined;
  await store.dispatch(GET_BROADCAST_LOGS, {
    settingId,
    page: logPage.value,
    limit: 20,
  });
  loadingLogs.value = false;
};

const openAdd = () => {
  editingId.value = undefined;
  editingData.value = {};
  modalOpen.value = true;
};

const openEdit = (s: BroadcastSetting) => {
  editingId.value = s.id;
  editingData.value = { ...s };
  modalOpen.value = true;
};

const openRecipientEdit = (recipient: BroadcastRecipient) => {
  editingRecipientId.value = recipient.id;
  recipientForm.value = {
    name: recipient.name || '',
    nim: recipient.nim || '',
    noWhatsapp: recipient.noWhatsapp || '',
    email: recipient.email || '',
  };
  editRecipientModalOpen.value = true;
};

const closeRecipientModal = () => {
  editRecipientModalOpen.value = false;
  editingRecipientId.value = undefined;
  savingRecipient.value = false;
  recipientForm.value = { name: '', nim: '', noWhatsapp: '', email: '' };
};

const saveRecipient = async () => {
  const errors: string[] = [];
  if (!recipientForm.value.name.trim()) errors.push('Nama penerima wajib diisi.');
  if (!recipientForm.value.noWhatsapp?.trim() && !recipientForm.value.email?.trim()) {
    errors.push('Minimal salah satu dari WhatsApp atau Email wajib diisi.');
  }

  if (recipientForm.value.email?.trim()) {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientForm.value.email.trim());
    if (!isEmailValid) errors.push('Format email tidak valid.');
  }

  if (errors.length) {
    Swal.fire({
      title: 'Validasi',
      html: errors.join('<br>'),
      icon: 'warning',
      confirmButtonColor: '#003793',
    });
    return;
  }

  if (!editingRecipientId.value) return;

  savingRecipient.value = true;
  try {
    await store.dispatch(PUT_BROADCAST_MEMBER, {
      id: editingRecipientId.value,
      data: {
        name: recipientForm.value.name.trim(),
        nim: recipientForm.value.nim?.trim() || null,
        noWhatsapp: recipientForm.value.noWhatsapp?.trim() || null,
        email: recipientForm.value.email?.trim() || null,
      },
    });
    await store.dispatch(GET_BROADCAST_MEMBERS);
    closeRecipientModal();
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({
      title: 'Error',
      text: apiError?.response?.data?.message || apiError?.message || 'Gagal menyimpan penerima.',
      icon: 'error',
      confirmButtonColor: '#003793',
    });
    savingRecipient.value = false;
  }
};

const handleModalClose = async () => {
  modalOpen.value = false;
  editingId.value = undefined;
  editingData.value = {};
  loadingSettings.value = true;
  await store.dispatch(GET_BROADCAST_SETTINGS);
  loadingSettings.value = false;
};

const runNow = async (id: number) => {
  const confirm = await Swal.fire({
    title: 'Blast sekarang?',
    text: 'Notifikasi akan dikirim ke semua penerima dalam setting ini.',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Ya, blast!',
    confirmButtonColor: '#003793',
    cancelButtonColor: '#8c8c94',
    cancelButtonText: 'Batal'
  });
  if (!confirm.isConfirmed) return;

  blasting.value = id;
  try {
    const result = await store.dispatch(RUN_BROADCAST, id) as BroadcastRunResponse;
    const runLogs = result?.logs || [];
    const waSent = runLogs.filter((log) => log.waStatus === 'sent').length;
    const waFailed = runLogs.filter((log) => log.waStatus === 'failed').length;
    const emailSent = runLogs.filter((log) => log.emailStatus === 'sent').length;
    const emailFailed = runLogs.filter((log) => log.emailStatus === 'failed').length;
    Swal.fire({
      title: waFailed || emailFailed ? 'Blast selesai dengan catatan' : 'Blast berhasil',
      html: `
        <div style="text-align:left;line-height:1.7">
          <div>WhatsApp terkirim: <strong>${waSent}</strong></div>
          <div>WhatsApp gagal: <strong>${waFailed}</strong></div>
          <div>Email terkirim: <strong>${emailSent}</strong></div>
          <div>Email gagal: <strong>${emailFailed}</strong></div>
        </div>
      `,
      icon: waFailed || emailFailed ? 'warning' : 'success',
      confirmButtonColor: '#003793',
    });
    await store.dispatch(GET_BROADCAST_SETTINGS);
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({
      title: 'Error', 
      text: apiError?.response?.data?.message || apiError?.message || 'Gagal mengirim broadcast.', 
      icon: 'error',
      confirmButtonColor: '#003793',
    });
  } finally {
    blasting.value = null;
  }
};

const deleteSetting = async (id: number) => {
  const confirm = await Swal.fire({
    title: 'Hapus pengaturan ini?',
    text: 'Jadwal yang dihapus tidak akan dikirimkan lagi.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Ya, hapus',
    confirmButtonColor: '#ef4444',
    cancelButtonColor: '#8c8c94',
    cancelButtonText: 'Batal'
  });
  if (!confirm.isConfirmed) return;
  try {
    await store.dispatch(DELETE_BROADCAST_SETTING, id);
    await store.dispatch(GET_BROADCAST_SETTINGS);
  } catch (err: unknown) {
    const apiError = err as ApiErrorResponse;
    Swal.fire({
      title: 'Error', 
      text: apiError?.response?.data?.message || apiError?.message || 'Gagal menghapus.', 
      icon: 'error',
      confirmButtonColor: '#003793',
    });
  }
};

const scheduleDayLabel = (s: BroadcastSetting) => {
  if (s.scheduleInterval === 'weekly') {
    const days = ['', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu'];
    return days[s.scheduleDay] || s.scheduleDay;
  }
  return `Tanggal ${s.scheduleDay}`;
};

const formatDate = (d?: string | null) => {
  if (!d) return '-';
  return new Date(d).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' });
};

const statusClass = (status: BroadcastDeliveryStatus | string) => {
  if (status === 'sent') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (status === 'failed') return 'bg-rose-50 text-rose-700 border-rose-200';
  return 'bg-slate-50 text-slate-500 border-slate-200';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "Broadcast" }),
    (modalOpen.value)
      ? (_openBlock(), _createBlock(FormBroadcastSetting, {
          key: 0,
          title: editingId.value ? 'Edit Pengaturan Broadcast' : 'Tambah Pengaturan Broadcast',
          data: editingData.value,
          id: editingId.value,
          onClose: handleModalClose
        }, null, 8, ["title", "data", "id"]))
      : _createCommentVNode("", true),
    (addRecipientModalOpen.value)
      ? (_openBlock(), _createBlock(FormBroadcastRecipient, {
          key: 1,
          onClose: handleRecipientModalClose
        }))
      : _createCommentVNode("", true),
    (editRecipientModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm",
          onClick: _withModifiers(closeRecipientModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(saveRecipient, ["prevent"])
            }, [
              _createElementVNode("div", { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }, [
                _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-lg font-bold text-slate-900" }, "Edit Penerima Default"),
                  _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Perbarui kontak yang dipakai sebagai daftar broadcast default.")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
                  onClick: closeRecipientModal
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                      _createTextVNode("Nama "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ]),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama penerima pesan.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recipientForm.value.name) = $event)),
                    type: "text",
                    class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                    placeholder: "Nama penerima"
                  }, null, 512), [
                    [_vModelText, recipientForm.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "NIM / Relasi"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Identitas atau relasi penerima.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((recipientForm.value.nim) = $event)),
                    type: "text",
                    class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                    placeholder: "13523062 atau Orang Tua Asuh"
                  }, null, 512), [
                    [_vModelText, recipientForm.value.nim]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "WhatsApp"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nomor untuk kanal WA.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((recipientForm.value.noWhatsapp) = $event)),
                    type: "text",
                    class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                    placeholder: "628..."
                  }, null, 512), [
                    [_vModelText, recipientForm.value.noWhatsapp]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Email"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Alamat untuk kanal email.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((recipientForm.value.email) = $event)),
                    type: "email",
                    class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                    placeholder: "nama@email.com"
                  }, null, 512), [
                    [_vModelText, recipientForm.value.email]
                  ])
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "px-5 py-3 text-xs text-slate-400" }, "Minimal salah satu dari WhatsApp atau Email wajib diisi.", -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: closeRecipientModal,
                  class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100"
                }, " Batal "),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: savingRecipient.value,
                  class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm transition-all hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-60"
                }, _toDisplayString(savingRecipient.value ? 'Menyimpan...' : 'Simpan'), 9, _hoisted_9)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("section", _hoisted_11, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10" }, null, -1)),
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10" }, null, -1)),
        _createElementVNode("div", _hoisted_12, [
          _cache[19] || (_cache[19] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-2xl font-bold md:text-4xl" }, "Broadcast Pesan"),
            _createElementVNode("p", { class: "mt-2 max-w-2xl text-sm leading-relaxed text-blue-100" }, " Kelola pengaturan pesan massal via WhatsApp dan Email untuk pengingat donasi dan iuran. ")
          ], -1)),
          _createElementVNode("button", {
            class: "inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-[#003793] shadow-lg transition-all hover:-translate-y-px hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70 sm:w-auto",
            onClick: openAdd
          }, [
            _createVNode(IcPlus, { class: "w-4 h-4" }),
            _cache[18] || (_cache[18] = _createTextVNode(" Tambah Pengaturan ", -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = 'settings')),
          class: _normalizeClass(["cursor-pointer rounded-2xl border-2 bg-white p-5 shadow-sm transition-all", activeTab.value === 'settings' ? 'border-[#003793] shadow-md' : 'border-slate-200 hover:border-blue-300'])
        }, [
          _createElementVNode("div", _hoisted_14, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "rounded-xl bg-blue-50 p-2.5 text-blue-600" }, [
              _createElementVNode("svg", {
                class: "h-6 w-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "stroke-width": "1.7"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                }),
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Pengaturan", -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(settings.value.length), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (activeTab.value = 'recipients')),
          class: _normalizeClass(["cursor-pointer rounded-2xl border-2 bg-white p-5 shadow-sm transition-all", activeTab.value === 'recipients' ? 'border-[#003793] shadow-md' : 'border-slate-200 hover:border-emerald-300'])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "rounded-xl bg-emerald-50 p-2.5 text-emerald-600" }, [
              _createElementVNode("svg", {
                class: "h-6 w-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "stroke-width": "1.7"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Penerima", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(members.value.length > 0 ? members.value.length : 'Lihat'), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (activeTab.value = 'logs')),
          class: _normalizeClass(["cursor-pointer rounded-2xl border-2 bg-white p-5 shadow-sm transition-all", activeTab.value === 'logs' ? 'border-[#003793] shadow-md' : 'border-slate-200 hover:border-amber-300'])
        }, [
          _createElementVNode("div", _hoisted_18, [
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "rounded-xl bg-amber-50 p-2.5 text-amber-600" }, [
              _createElementVNode("svg", {
                class: "h-6 w-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                "stroke-width": "1.7"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ])
            ], -1)),
            _createElementVNode("div", null, [
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Log Pengiriman", -1)),
              _createElementVNode("p", _hoisted_19, _toDisplayString(logs.value.pagination?.total || 'Cek'), 1)
            ])
          ])
        ], 2)
      ]),
      (activeTab.value === 'settings')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex items-center justify-between border-b border-slate-100 px-6 py-4" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Pengaturan"),
                _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Konfigurasi pesan dan jadwal otomatis.")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("table", _hoisted_22, [
                _cache[31] || (_cache[31] = _createElementVNode("thead", { class: "bg-blue-900" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Nama"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Jenis Iuran"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Interval"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Jadwal"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Status"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Terakhir Dikirim"),
                    _createElementVNode("th", { class: "px-4 py-3.5 text-center text-[11px] font-bold text-blue-100" }, "Aksi")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_23, [
                  (loadingSettings.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "px-6 py-10 text-center"
                        }, [
                          _createElementVNode("div", { class: "mx-auto h-6 w-6 animate-spin rounded-full border-2 border-[#003793] border-t-transparent" }),
                          _createElementVNode("p", { class: "mt-2 text-sm font-medium text-slate-500" }, "Memuat data...")
                        ], -1)
                      ]))]))
                    : (!settings.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[29] || (_cache[29] = [
                          _createElementVNode("td", {
                            colspan: "7",
                            class: "px-6 py-10 text-center text-sm text-slate-400 italic"
                          }, "Belum ada pengaturan broadcast.", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(settings.value, (s) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: s.id,
                            class: "transition-colors hover:bg-blue-50/40"
                          }, [
                            _createElementVNode("td", _hoisted_26, _toDisplayString(s.name), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(s.jenisIuran), 1),
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(s.scheduleInterval === '3months' ? '3 Bulan' : s.scheduleInterval === 'monthly' ? 'Bulanan' : 'Mingguan'), 1)
                            ]),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(scheduleDayLabel(s)), 1),
                            _createElementVNode("td", _hoisted_31, [
                              _createElementVNode("span", {
                                class: _normalizeClass([s.isActive ? 'bg-emerald-100 text-emerald-700 border-emerald-200' : 'bg-slate-100 text-slate-400 border-slate-200', "rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-tight"])
                              }, _toDisplayString(s.isActive ? 'Aktif' : 'Nonaktif'), 3)
                            ]),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(s.lastRunAt ? formatDate(s.lastRunAt) : '-'), 1),
                            _createElementVNode("td", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  class: "flex items-center gap-1 rounded-lg bg-green-50 px-2 py-1.5 text-xs font-bold text-green-700 transition hover:bg-green-100 disabled:opacity-50",
                                  disabled: blasting.value === s.id,
                                  onClick: ($event: any) => (runNow(s.id)),
                                  title: "Kirim Sekarang"
                                }, [
                                  _cache[30] || (_cache[30] = _createElementVNode("svg", {
                                    class: "h-3.5 w-3.5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2.5",
                                      d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(blasting.value === s.id ? 'Mengirim...' : 'Blast'), 1)
                                ], 8, _hoisted_35),
                                _createElementVNode("button", {
                                  class: "p-1.5 text-amber-600 hover:bg-amber-50 rounded-lg transition-colors",
                                  title: "Edit",
                                  onClick: ($event: any) => (openEdit(s))
                                }, [
                                  _createVNode(IcEdit, { class: "w-4 h-4" })
                                ], 8, _hoisted_36),
                                _createElementVNode("button", {
                                  class: "p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors",
                                  title: "Hapus",
                                  onClick: ($event: any) => (deleteSetting(s.id))
                                }, [
                                  _createVNode(IcTrash, { class: "w-4 h-4" })
                                ], 8, _hoisted_37)
                              ])
                            ])
                          ]))
                        }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'recipients')
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _cache[34] || (_cache[34] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Daftar Penerima Default"),
                _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Anggota yang akan menerima broadcast jika setting tidak menentukan penerima sendiri.")
              ], -1)),
              _createElementVNode("button", {
                class: "inline-flex items-center gap-2 rounded-full bg-[#003793] px-4 py-2 text-sm font-bold text-white shadow-sm transition-all hover:-translate-y-px hover:bg-blue-800 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500/50",
                onClick: openAddRecipient
              }, [
                _createVNode(IcPlus, { class: "w-4 h-4" }),
                _cache[33] || (_cache[33] = _createTextVNode(" Tambah Penerima ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("table", _hoisted_41, [
                _cache[40] || (_cache[40] = _createElementVNode("thead", { class: "bg-blue-900" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Nama"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "NIM / Relasi"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "No. WhatsApp"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Email"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-right text-[11px] font-bold text-blue-100" }, "Aksi")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_42, [
                  (loadingMembers.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [...(_cache[35] || (_cache[35] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "px-6 py-10 text-center"
                        }, [
                          _createElementVNode("div", { class: "mx-auto h-6 w-6 animate-spin rounded-full border-2 border-[#003793] border-t-transparent" }),
                          _createElementVNode("p", { class: "mt-2 text-sm font-medium text-slate-500" }, "Memuat kontak...")
                        ], -1)
                      ]))]))
                    : (!members.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [...(_cache[36] || (_cache[36] = [
                          _createElementVNode("td", {
                            colspan: "5",
                            class: "px-6 py-10 text-center text-sm text-slate-400 italic"
                          }, "Belum ada penerima. Klik \"Tambah Penerima\" untuk menambah.", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(members.value, (m) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: m.id,
                            class: "transition-colors hover:bg-blue-50/40"
                          }, [
                            _createElementVNode("td", _hoisted_45, _toDisplayString(m.name), 1),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(m.nim || '-'), 1),
                            _createElementVNode("td", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, [
                                _cache[37] || (_cache[37] = _createElementVNode("svg", {
                                  class: "h-3 w-3",
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24",
                                  "stroke-width": "2.5"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(m.noWhatsapp || '-'), 1)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_49, _toDisplayString(m.email || '-'), 1),
                            _createElementVNode("td", _hoisted_50, [
                              _createElementVNode("button", {
                                class: "mr-2 inline-flex items-center gap-1.5 rounded-lg bg-amber-50 px-3 py-1.5 text-xs font-bold text-amber-700 transition hover:bg-amber-100",
                                onClick: ($event: any) => (openRecipientEdit(m))
                              }, [
                                _createVNode(IcEdit, { class: "h-3.5 w-3.5" }),
                                _cache[38] || (_cache[38] = _createTextVNode(" Edit ", -1))
                              ], 8, _hoisted_51),
                              _createElementVNode("button", {
                                class: "inline-flex items-center gap-1.5 rounded-lg bg-red-50 px-3 py-1.5 text-xs font-bold text-red-700 transition hover:bg-red-100",
                                title: "Hapus",
                                onClick: ($event: any) => (deleteRecipient(m.id))
                              }, [
                                _createVNode(IcTrash, { class: "h-3.5 w-3.5" }),
                                _cache[39] || (_cache[39] = _createTextVNode(" Hapus ", -1))
                              ], 8, _hoisted_52)
                            ])
                          ]))
                        }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'logs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _cache[41] || (_cache[41] = _createElementVNode("div", null, [
                _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Log Pengiriman"),
                _createElementVNode("p", { class: "mt-1 text-xs text-slate-500" }, "Histori status broadcast.")
              ], -1)),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(AppSelect, {
                  modelValue: logFilterId.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((logFilterId).value = $event)),
                  options: broadcastFilterOptions.value,
                  onChange: _cache[8] || (_cache[8] = () => { logPage.value = 1; loadLogs(); })
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("table", _hoisted_57, [
                _cache[44] || (_cache[44] = _createElementVNode("thead", { class: "bg-blue-900" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Waktu"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Broadcast"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Penerima"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Kanal WhatsApp"),
                    _createElementVNode("th", { class: "px-6 py-3.5 text-left text-[11px] font-bold text-blue-100" }, "Kanal Email")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_58, [
                  (loadingLogs.value)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [...(_cache[42] || (_cache[42] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "px-6 py-10 text-center"
                        }, [
                          _createElementVNode("div", { class: "mx-auto h-6 w-6 animate-spin rounded-full border-2 border-[#003793] border-t-transparent" }),
                          _createElementVNode("p", { class: "mt-2 text-sm font-medium text-slate-500" }, "Memuat log...")
                        ], -1)
                      ]))]))
                    : (!logs.value.data?.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_60, [...(_cache[43] || (_cache[43] = [
                          _createElementVNode("td", {
                            colspan: "5",
                            class: "px-6 py-10 text-center text-sm text-slate-400 italic"
                          }, "Belum ada riwayat pengiriman.", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(logs.value.data, (l) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: l.id,
                            class: "transition-colors hover:bg-blue-50/40"
                          }, [
                            _createElementVNode("td", _hoisted_61, _toDisplayString(formatDate(l.sentAt)), 1),
                            _createElementVNode("td", _hoisted_62, _toDisplayString(l.broadcastName), 1),
                            _createElementVNode("td", _hoisted_63, _toDisplayString(l.recipientName || '-'), 1),
                            _createElementVNode("td", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(l.waNumber || '-'), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass([statusClass(l.waStatus), "rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-tight border"])
                                }, _toDisplayString(l.waStatus), 3),
                                (l.waError)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "max-w-[220px] truncate text-[11px] text-rose-600",
                                      title: l.waError
                                    }, _toDisplayString(l.waError), 9, _hoisted_67))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("span", _hoisted_70, _toDisplayString(l.email || '-'), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass([statusClass(l.emailStatus), "rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-tight border"])
                                }, _toDisplayString(l.emailStatus), 3),
                                (l.emailError)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "max-w-[220px] truncate text-[11px] text-rose-600",
                                      title: l.emailError
                                    }, _toDisplayString(l.emailError), 9, _hoisted_71))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                ])
              ])
            ]),
            (logs.value.pagination?.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createElementVNode("span", _hoisted_73, "Halaman " + _toDisplayString(logPage.value) + " dari " + _toDisplayString(logs.value.pagination?.totalPages), 1),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("button", {
                      class: "rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50",
                      disabled: logPage.value <= 1,
                      onClick: _cache[9] || (_cache[9] = () => { logPage.value--; loadLogs(); })
                    }, "Prev", 8, _hoisted_75),
                    _createElementVNode("button", {
                      class: "rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50",
                      disabled: logPage.value >= logs.value.pagination?.totalPages,
                      onClick: _cache[10] || (_cache[10] = () => { logPage.value++; loadLogs(); })
                    }, "Next", 8, _hoisted_76)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})